import { render } from "./ValidationMessages.vue?vue&type=template&id=c0f8af56"
import script from "./ValidationMessages.vue?vue&type=script&lang=js"
export * from "./ValidationMessages.vue?vue&type=script&lang=js"

import "./ValidationMessages.vue?vue&type=style&index=0&id=c0f8af56&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__